import { useAuthInfo } from '@propelauth/react';
import { useMemo } from 'react';

const useIsAdmin = () => {
  const { user } = useAuthInfo();

  return useMemo(() => user && user.email.endsWith('@tryvelos.com'), [user]);
};
export default useIsAdmin;
